import script from "./TooltipComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TooltipComponent.vue?vue&type=style&index=0&id=e1fb2f8e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1fb2f8e"]])

export default __exports__